export const SET_ONBOARDING_MODAL_VISIBILITY = 'SET_ONBOARDING_MODAL_VISIBILITY';
export const SET_ONBOARDING_CURRENT_ACTIVE_STEP = 'SET_ONBOARDING_CURRENT_ACTIVE_STEP';
export const PREVIOUS_STEP = 'PREVIOUS_STEP';
export const NEXT_STEP = 'NEXT_STEP';